import { Injectable } from '@angular/core';
const IntegratedBespinSso = require('../../../components/sso/integrated.bespinsso');
const integratedBespinsso = new IntegratedBespinSso(getAlertNowInternalOpenApiUrl());

function getAlertNowInternalOpenApiUrl() {

    const protocol = window.location.protocol;
    const domainList = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
    const isDev = domainList[0] === 'alertnowdev' || domainList[0] === 'alertnowdqa';
    console.log(isDev);
    const domainPrepix = domainList[0];
    domainList[0] = '';
    const domain = domainList.join('.');

    let alertnowInternalOpenApiUrl = '';

    switch (process.env.NODE_ENV) {
        case 'localhost':
            console.log('localhost');
            alertnowInternalOpenApiUrl = `https://alertnowinternalapidev.opsnow.com`;
            //alertnowInternalOpenApiUrl = `http://backend.opsnow.com:9140`;
            break;
        case 'dqa':
            console.log('dqa');
            alertnowInternalOpenApiUrl = `https://servicedev${domain}`;
            break;
        case 'dev':
            console.log('dev');
            alertnowInternalOpenApiUrl = `${protocol}//${domainPrepix}${domain}`;
            break;
        case 'deveks':
            console.log('deveks');
            alertnowInternalOpenApiUrl = `${protocol}//alertnowinternalapidev.opsnow.com`;
            break;
        case 'prdeks':
            console.log('prdeks');
            alertnowInternalOpenApiUrl = `${protocol}//alertnowinternalapi.an.opsnow.com`;
            break;
        case 'development':
            console.log('development');
            alertnowInternalOpenApiUrl = `${protocol}//${domainPrepix}${domain}`;
            break;
        case 'kubernetes':
            console.log('kubernetes');
            alertnowInternalOpenApiUrl = isDev ? alertnowInternalOpenApiUrl = `https://servicedev${domain}` : `https://service${domain}`;
            break;
        case 'prod':
            console.log('prod');
            alertnowInternalOpenApiUrl = `${protocol}//${domainPrepix}${domain}`;
            break;
        case 'production':
            console.log('production');
            alertnowInternalOpenApiUrl = `${protocol}//${domainPrepix}${domain}`;
            break;
        default:
            alertnowInternalOpenApiUrl = `${protocol}//${domainPrepix}${domain}`;
    }
    return alertnowInternalOpenApiUrl;

}

@Injectable()
export class IntegratedKeycloakloginService {
    constructor() {
    };

    init() {
        return integratedBespinsso.init();
    }

    isLoggedIn() {
        return integratedBespinsso.getKeycloak().authenticated;
    }

    getKeycloak() {
        return integratedBespinsso.getKeycloak();
    }

    login() {
        return new Promise((resolve, reject) => {
            // URL에서 idp_hint 파라미터 추출
            const urlParams = new URLSearchParams(window.location.search);
            const idp = urlParams.get('idp_hint');

            // Keycloak 로그인 옵션 설정
            const locale = $.cookie('BSP_LangCode') || 'en';
            const keycloakLoginParams: any = {locale: locale};

            // idp_hint가 있으면 추가
            if (idp) {
                keycloakLoginParams.idpHint = idp;
            }

            integratedBespinsso.getKeycloak().login(keycloakLoginParams);
        });
    }



    
    logout(options = null) {
        return new Promise((resolve, reject) => {
            integratedBespinsso.customLogout(options);
        });
    }
  
 

    getSessionCount() {
        return integratedBespinsso.getSessionCount();
    }

    logoutAllSession(withoutCurrent = false) {
        return integratedBespinsso.logoutAllSession(withoutCurrent);
    }

    isAlertNowUser() {
        return integratedBespinsso.isAlertNowUser();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/integrated.keycloaklogin.service.ts